import { getProjectId } from "../utilities/firebase_utils";

/**
 * The command palette / guided-navigation surfaces are on by default in
 * local / dev / qa and stay OFF in production until we explicitly flip them.
 * Gate by project id (prod = arcwise-ad50c) so it's environment-wide, not
 * per-org — mirrors src/locations/onboarding/llm/featureGate.js. One source of
 * truth for every W1 mount point.
 */
const PROD_PROJECT_ID = "arcwise-ad50c";

export const paletteEnabled = () => getProjectId() !== PROD_PROJECT_ID;

/**
 * Ledger (the docked assistant drawer, wave 2) is on in local / dev / qa and
 * stays OFF in production until we explicitly flip it — same environment-wide
 * project-id gate as the palette. When off, HELP falls back to the W1 guide
 * palette and the palette's Tab-escalation hint is hidden.
 */
export const ledgerEnabled = () => getProjectId() !== PROD_PROJECT_ID;

/**
 * Trial mode (play-before-onboarding, wave 3) — the onboarding fork, trial
 * banner, graduation wizard, org-selector chip and email-preview surfacing.
 * On in local / dev / qa, OFF in production until we explicitly flip it —
 * same environment-wide project-id gate as the palette and Ledger.
 */
export const trialEnabled = () => getProjectId() !== PROD_PROJECT_ID;
